import Admin from "../components/Admin";
import Dashboard from "../components/Dashboard";
import NewPurchase from "../components/NewPurchase";
import NewSales from "../components/NewSales";
import Purchases from "../components/Purchases";
import Sales from "../components/Sales";
import StockDetails from "../components/StockDetails";

const displayNavOptions = {
  dashboard:{
    displayName: "Dashboard",
    component: <Dashboard />,
  },
  stockDetails: {
    displayName: "Stock Details",
    component: <StockDetails />,
  },
  newSale: {
    displayName: "New Sales",
    component: <NewSales />,
  },
  newPurchase: {
    displayName: "New Purchase",
    component: <NewPurchase />,
  },
  sales: {
    displayName: "Sales",
    component: <Sales />,
  },
  purchases: {
    displayName: "Purchases",
    component: <Purchases />,
  },
  admin: {
    displayName: "Admin",
    component: <Admin />,
  },

};

export default displayNavOptions;
